let filterButton, filterForm, resultsHeading;

function toggleFilter() {
    if( filterButton.hasClass('is-open') ) {
        filterButton.removeClass('is-open');

        if( isDesktop() ) {
            filterForm.fadeOut(200).promise().done(function() {
                resultsHeading.fadeIn(200);
            });
        } else {
            filterForm.slideUp(200);
        }
    } else {
        filterButton.addClass('is-open');

        if( isDesktop() ) {
            resultsHeading.fadeOut(200).promise().done(function() {
                filterForm.fadeIn(200);
            });
        } else {
            filterForm.slideDown(200);
        }
    }
}

function initFilter() {
    if( !$('.search-top__filter').length ) {
        return false;
    }

    // Set variables
    filterButton = $('.search-top__filter');
    filterForm = (isDesktop()) ? $('.search-top .columns .advanced-search') : $('.search-top .wrapper > .advanced-search');
    resultsHeading = $('.search-top h3');

    // Listen for button click
    filterButton.on('click', toggleFilter);
}

$(document).ready(function() {
    initFilter();
});